export default "__VITE_ASSET__6WtZmmcn__"